import { Component, ElementRef, inject, Input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'mailgun-html',
  template: ``,
  standalone: true,
  hostDirectives: [SsrMarkToUnwrapDirective],
})
export class EmailMailgunHtmlComponent {
  public sanitizer = inject(DomSanitizer);
  public elRef = inject(ElementRef);

  @Input() public html: WrappedValue<string | number>;

  public ngOnChanges() {
    this.update();
  }

  private update() {
    const el: HTMLElement = this.elRef.nativeElement;

    if (this.html.isHtml()) {
      el.innerHTML = this.getSafeValue()!;
    } else {
      el.innerText = this.getSafeValue()!;
    }
  }

  private getSafeValue() {
    return this.sanitizer.sanitize(SecurityContext.NONE, this.html.toJSON());
  }
}
